<ng-container>
  <div class="row justify-content-center">
    <div class="d-grid gap-2 mx-auto">
      <button *ngIf="!showAddWellFile" class="btn btn-success" type="button" (click)="onAddWellFile()"><i class='fas fa-plus'></i> Add Well File</button>
    </div>
  </div>

  <div *ngIf="showAddWellFile" class="card rr-card m-0">
    <div class="card-body">
      <div class="d-flex justify-content-between align-items-end">
        <h5 class="mb-1"><strong>Add New Well File</strong></h5>
      </div>
      <div class="pt-2">
        <div class="form-group rr-form-group">
          <label for="field">Short Description</label>
          <input class="form-control rr-form-control" type="text" trim="blur" maxlength="500" placeholder="Ex: Tool damaged while pulling out of hole" [(ngModel)]="fileData.description" />
        </div>
        <div appDragNDrop (fileDropped)="onFileDropped($event)" class="card h-100 w-100 d-flex justify-content-center align-items-center add-img-btn pointer-cursor p-3" type="button" (click)="addFile()" style="min-height: 50px;" *ngIf="!selectedFile || (selectedFile == null)">
          <app-loading-indicator *ngIf="fileUploadInitiated" [message]="'Uploading file'"></app-loading-indicator>
          <div *ngIf="!fileUploadInitiated" class="d-flex flex-column align-items-center">
            <p class="mb-0">Drag & drop</p>
            <!--<p class="mb-0">or</p>-->
            <p class="mb-0">or <strong>Select a file</strong></p>
            <i class="fas fa-upload fa-2x pt-2 text-muted"></i>
          </div>
          <!--<span >  <strong></strong></span>-->
          <input style="display: none" type="file" id="fileUpload" #selectedFile (click)="selectedFile.value = null" value="" (change)="handleFileInput($event.target.files)" />
          <div class="pt-2 px-4">
            <div class="text-center">
              <span class="text-muted">Upload images, documents, or other files related to this well.</span>
            </div>
            <div class="text-center">
            </div>
          </div>
        </div>
        <div *ngIf="selectedFile">
          <label>Selected File <span class="text-muted">(Size)</span></label>
          <p>{{selectedFile.name}} <span class="pl-2 text-muted">({{selectedFile.size | division: 1048576: 3 | number : '1.0-3' }} MB)</span></p>
        </div>
        <div *ngIf="selectedFile && (storageType == 'jobsheet')" class="form-check">
          <label>Distribute File With Report <span><i class="pl-2 fas fa-question-circle" pTooltip="Choose whether or not to include the file as an attachment with the distributed report email." tooltipPosition="right"></i></span></label>
          <span class="pl-2"></span>
          <div class="d-block btn-group" role="button">
            <button style="width: 75px" *ngIf="fileData.isAttachment" class="btn btn-success btn-sm" type="button">Yes</button>
            <button style="width: 75px" *ngIf="!fileData.isAttachment" (click)="handleToggleIsAttachment(true)" class="btn btn-outline-secondary btn-sm" type="button">Yes</button>
            <button style="width: 75px" *ngIf="fileData.isAttachment" (click)="handleToggleIsAttachment(false)" class="btn btn-outline-secondary btn-sm" type="button">No</button>
            <button style="width: 75px" *ngIf="!fileData.isAttachment" class="btn btn-danger btn-sm" type="button">No</button>
          </div>
        </div>
        <div class="text-center pt-2">
          <span *ngIf="!fileUploadInitiated && errorUploadMessage" class="text-danger"><strong>{{errorUploadMessage}}</strong></span>
        </div>
      </div>
      <div class="d-flex justify-content-end pt-2">
        <button class="btn btn-sm btn-outline-secondary" (click)="resetFileAndFileData(true)" type="button">Cancel</button>
        <span class="pr-2"></span>
        <button class="btn btn-sm btn-dark" [disabled]="fileUploadInitiated || !selectedFile" (click)="onUploadFile()" title="Upload File" type="button">
          <span *ngIf="!fileUploadInitiated">Upload</span>
          <span *ngIf="fileUploadInitiated"><span class="spinner-border spinner-border-sm"></span> Uploading...</span>
        </button>
      </div>
    </div>
  </div>
</ng-container>
